import { BenefitsSection } from "./components/benefits";
import { CommunitySection } from "./components/community";
import { ContactSection } from "./components/contact";
import { FAQSection } from "./components/faq";
import { FeaturesSection } from "./components/product";
import { FooterSection } from "./components/footer";
import { HeroSection } from "./components/hero";
import { PricingSection } from "./components/pricing";
import { ServicesSection } from "./components/services";
import { SponsorsSection } from "./components/sponsors";
import { TeamSection } from "./components/team";
import { TestimonialSection } from "./components/testimonial";
import SEO from "@/shared/components/seo";

// interface Props {}

function LandingPage() {
  // const {} = props;

  return (
    <div className="overflow-x-hidden">
      <SEO
        title="Home"
        description="Revolutionize your car wash business with MikroSell's all-in-one POS. Manage orders, manage services, streamline operations, manage employees, track reports and boost satisfaction."
        url="https://carwash.mikrosell.com"
        image={`${window.location.href}/hero-image-dark.png`}
      />
      <HeroSection />
      {/* <SponsorsSection /> */}
      {/* <BenefitsSection /> */}
      <FeaturesSection />
      {/* <ServicesSection /> */}
      <TestimonialSection />
      {/* <TeamSection /> */}
      {/* <CommunitySection /> */}
      {/* <PricingSection /> */}
      <ContactSection />
      {/* <FAQSection /> */}
      <FooterSection />
    </div>
  );
}

export default LandingPage;
